import { client } from "../src/sanityClient"

export async function getInformation() {
  return client.fetch(`
    *[_type == "information"][0]
  `)
}